import styled, { css } from 'styled-components'

import { brandSecondary, btnSecondaryColor, fontWeightLight, media, white } from '../../../../../utils/style-utils'
import IconLink, { IconLinkProps } from '../../../../IconLink'

interface Props extends IconLinkProps {
  isEnabled: boolean
}

export const StyledIconLink = styled(IconLink)<Props>`
  display: flex;
  flex: 1;
  justify-content: center;
  color: ${white};
  overflow: hidden;

  ${media.xs`
    & > span {
      font-size: 0.65rem;
      line-height: 0.1rem;
      margin-top: 1rem;
      font-weight: ${fontWeightLight};
    }

    & > svg {
      transform: scale(0.75);
    }
  `}

  & > svg {
    fill: ${white};
    width: auto;
  }

  ${media.desktopHoverOnly`
    &:hover {
      & > svg {
        fill: ${brandSecondary};
      }

      & > span {
        color: ${brandSecondary};
      }
    }
  `}

  ${({ isEnabled }) =>
    isEnabled
      ? css`
          pointer-events: none;
          cursor: default;
          color: ${btnSecondaryColor};

          & > svg {
            fill: ${btnSecondaryColor};
            transform: scale(0.6);
          }
        `
      : ''}
`
